/**
 * Stable machine-readable error codes (CFG-007). Clients branch on `code`, never on `message`.
 * Codes are append-only: renaming or removing one is a breaking API change (/api/v2).
 */
export const ERROR_CODES = {
    VALIDATION_FAILED: 400,
    UNAUTHENTICATED: 401,
    MFA_REQUIRED: 403,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    PAYLOAD_TOO_LARGE: 413,
    UNSUPPORTED_MEDIA_TYPE: 415,
    RATE_LIMITED: 429,
    INTERNAL_ERROR: 500,
    SERVICE_UNAVAILABLE: 503,
    /** No validated model is registered for the requested task (Protocol §27). Never a fake result. */
    AI_NOT_CONFIGURED: 503,
};
export function httpStatusFor(code) {
    return ERROR_CODES[code];
}
export function isErrorCode(value) {
    return typeof value === "string" && Object.hasOwn(ERROR_CODES, value);
}
//# sourceMappingURL=error-codes.js.map